import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function ProtectedRoute({ children, allowedRoles }) {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="inline-block w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-3" />
          <p className="text-sm text-slate-500">Loading session…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    const noRoleAssigned = !role;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center max-w-sm">
          <p className="text-4xl mb-3">🔒</p>
          <h2 className="text-lg font-semibold text-slate-900 mb-1">Access Denied</h2>
          <p className="text-sm text-slate-500">
            {noRoleAssigned
              ? "Your account has no role assigned. Please contact your administrator."
              : `Your role (${role}) does not have permission to view this page.`}
          </p>
        </div>
      </div>
    );
  }

  return children;
}
